import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Text from '~components/atoms/Text';
import AvailableInventorySearchAndFilterBar from './AvailableInventorySearchAndFilterBar';

import * as Styles from './_availableInventory.module.scss';
import PhysicalSilverTable from './PhysicalSilverTable';
import PaperSilverTable from './PaperSilverTable';
import SilverProductTable from './SilverProductTable';
import { MetalTypeEnum } from '~utils/enums';

const AvailableSilverInventory = () => {
    const dispatch = useAppDispatch();

    const filters = useAppSelector(state => state.dashboard.dashboardSilverProductInventoryFilters);

    useEffect(() => {
        if (!filters.branchCode) return;

        dispatch(
            combinedActions.dashboardGetDashboardProductInventoryAttempt({
                ...filters,
                metalType: MetalTypeEnum.Silver,
            })
        );
    }, [filters.branchCode]);

    return (
        <div className={Styles.container}>
            <div className={Styles['title-container']}>
                <Text
                    label='AVAILABLE INVENTORY'
                    className={Styles.title}
                    isBold
                />

                <AvailableInventorySearchAndFilterBar />
            </div>

            <div className={Styles['table-container']}>
                <PhysicalSilverTable />

                <PaperSilverTable />

                <SilverProductTable />

            </div>
        </div>
    );
};

export default AvailableSilverInventory;
